<template>
	<div class="hello">
		<div class="dom_width">
			<img class="img_block" v-for="(item, index) in listImg" :key="index" :src="item" alt="" />
		</div>
	</div>
</template>

<script>
export default {
	name: 'HelloWorld',
	data() {
		return {
			listImg: [
				'http://82.157.26.62:19010/uploads/20220523/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20220523152248.jpg',
				'http://82.157.26.62:19010/uploads/20220307/%E9%91%AB%E6%BA%90%E5%86%9C%E5%9C%BA%E8%A5%BF%E7%93%9C(1).png',
				'http://82.157.26.62:19010/uploads/20220520/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20220520134751.jpg',
			],
		}
	},
	created() {},
	mounted() {
		// 获取所有的img标签
		let imgList = document.querySelectorAll('.img_block')
		// 获取父元素宽高
		let parentWh = imgList[0].parentNode
		let wid = this.getWidHei(parentWh, 'width')
		let hei = this.getWidHei(parentWh, 'height')

		// 等比压缩图片
		// this.AutoSize(imgList, wid, hei)
	},
	methods: {
		AutoSize(listImg, maxWidth, maxHeight) {
			//原图片原始地址（用于获取原图片的真实宽高，当<img>标签指定了宽、高时不受影响）
			let image = new Image()
			for (let i = 0; i < listImg.length; i++) {
				// 获取每一个图片的宽高
				image.src = listImg[i].src

				// 当图片比图片框小时不做任何改变
				if (image.width < maxWidth && image.height < maxHeight) {
					//原图片宽高比例 大于 图片框宽高比例
					listImg[i].width = image.width
					listImg[i].height = image.height
				} else {
					//原图片宽高比例 大于 图片框宽高比例,则以框的宽为标准缩放，反之以框的高为标准缩放
					if (maxWidth / maxHeight <= image.width / image.height) {
						listImg[i].width = maxWidth //以框的宽度为标准
						listImg[i].height = maxWidth * (image.height / image.width)
					} else {
						listImg[i].width = maxHeight * (image.width / image.height)
						listImg[i].height = maxHeight //以框的高度为标准
					}
				}
			}
		},
		// 考虑 IE 的兼容性
		getStyle(el) {
			if (window.getComputedStyle) {
				return window.getComputedStyle(el, null)
			} else {
				return el.currentStyle
			}
		},
		// 通过当前元素获取宽高
		getWidHei(el, name) {
			let val = name === 'width' ? el.offsetWidth : el.offsetHeight,
				which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom']
			// display is none
			if (val === 0) {
				return 0
			}
			let style = this.getStyle(el)
			// 左右或上下两边的都减去
			for (let i = 0, a; (a = which[i++]); ) {
				val -= parseFloat(style['border' + a + 'Width']) || 0
				val -= parseFloat(style['padding' + a]) || 0
			}
			return val
		},
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.dom_width {
	width: 300px;
	height: 270px;
	background-color: skyblue;
}
img {
	/* width: 100%;
	height: 100%; */
	/* object-fit: contain; */
	/* width: 300px;
	height: 270px; */
	max-width: 100%;
	max-height: 100%;
}
</style>
